// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  vguildId: __t.u64().primaryKey().name("vguild_id"),
  settlementId: __t.u64().name("settlement_id"),
  trade: __t.string(),
  seat: __t.u32(),
  name: __t.string(),
  tag: __t.string(),
  worldId: __t.u64().name("world_id"),
  x: __t.f64(),
  z: __t.f64(),
  yaw: __t.f32(),
  tier: __t.u32(),
  masterVersona: __t.u64().name("master_versona"),
  termEnds: __t.timestamp().name("term_ends"),
  foundedAt: __t.timestamp().name("founded_at"),
  lastMeetingEpoch: __t.u64().name("last_meeting_epoch"),
  lastDuesDay: __t.u32().name("last_dues_day"),
  updatedAt: __t.timestamp().name("updated_at"),
});
